import { mutator } from 'satcheljs';
import getStore from '../store/store';
import discardEventOption from '../../actions/discardEventOption';
/**
 * Called when discard option is selected, resets the event options in store
 */
export default mutator(discardEventOption, function (actionMessage) {
    var optionState = getStore();
    optionState.defaultReminderTime = null;
    optionState.defaultMeetingDuration = null;
});
//# sourceMappingURL=discardEventOption.js.map